<template>
  <div class="main">
    <Header 
      :show="true"
      title="修改用户信息"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c" background="#FFFBE8" 
        text="注意：用户名不能跟现有的用户名一样"
      />
      <van-form 
        ref="update"
        @submit="submit"
      >
        <van-field
          v-model.trim="listQuery.username"
          label="用户名"
          placeholder="支持字母、数字或下划线"
          required
          disabled
          :rules="[{ validator: validUserName, message: '' }]"
        />
        <van-field
          v-model.trim="listQuery.password"
          label="登录密码"
          placeholder="支持字母、数字或下划线"
          required
          type="password" 
          :rules="[{ validator: validPassword, message: '' }]"
        />
        <van-field
          v-model.trim="listQuery.name"
          label="姓名"
          placeholder="仅支持中文"
          required
          :rules="[{ validator: validName, message: '' }]"
        />
        <van-field
          clickable
          name="picker"
          :value="listQuery.type"
          label="类别"
          placeholder="点击选择用户类别"
          required
          @click="type.show = true"
          :rules="[{ validator: validName, message: '' }]"
        />
        <van-popup v-model="type.show" position="bottom">
          <van-picker
            show-toolbar
            :columns="type.columns"
            @confirm="handlePersonTypeSelect"
            @cancel="type.show = false"
          />
        </van-popup>
        <van-field
          clickable
          name="picker"
          :value="listQuery.department"
          label="部门"
          placeholder="选择部门"
          required
          @click="department.show = true"
          :rules="[{ validator: validDepartment, message: '' }]"
        />
        <van-popup v-model="department.show" position="bottom">
          <van-picker
            show-toolbar
            :columns="department.columns"
            @confirm="handleDepartmentSelect"
            @cancel="department.show = false"
          />
        </van-popup>
        <van-field
          v-model.trim="listQuery.position"
          label="职位"
          placeholder="支持中文"
          required
          :rules="[{ validator: validPosition, message: '' }]"
        />
        <van-field 
          name="checkboxGroup" 
          label="角色"
          required
          :rules="[{ required: true }]"
        >
          <template #input>
            <van-checkbox-group v-model="listQuery.role" direction="horizontal" @change="handleChangeRole">
              <van-checkbox 
                v-for="item in roleOptions"
                :key="item.id"
                :name="item.id" 
                shape="square"
              >
              {{ item.name }}
              </van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field
          v-model.trim="listQuery.phone"
          label="手机号码"
          required
          placeholder="请输用户手机号码"
          maxlength="11"
          :rules="[{ validator: validPhone, message: '' }]"
        />
        <van-field
          v-model.trim="listQuery.email"
          label="电子邮箱"
          placeholder="请输电子邮箱"
        />
        <van-field
          v-model.trim="listQuery.remark"
          rows="2"
          autosize
          label="说明"
          type="textarea"
          maxlength="100"
          placeholder="请输入用户说明"
          show-word-limit
        />
        <div style="margin: .6rem 1rem;" v-if="checkPermission([143])">
          <van-button round block type="info" native-type="submit">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isUserName, isPassword, isChinese, isPhone, isEmail } from '@/utils/validate.js'
  import { getList as getDepartmentList } from '@/api/department.js'
  import { getList as getRoleList } from '@/api/role.js'
  import { updateOne } from '@/api/staff.js'

  export default {
    name: "ServiceSystemStaffUpdate",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        loading: false,
        listQuery: {
          serial: '',
          username: '',
          password: '',
          name: '',
          department: '',
          position: '',
          role: [],
          permission: [],
          phone: '',
          email: '',
          type: '员工',
          personType: 0,
          remark: ''
        },
        type: {
          show: false,
          columns: ['员工', '领导', '供应商', '其他']
        },
        department: {
          show: false,
          columns: []
        },
        role: {
          show: false,
          list: [],
          columns: []
        },
        roleOptions: []
      }
    },
    computed: {
      
    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleGetDepartmentList()
      this.handleGetRoleList()
    },
    beforeMount() {
      
    },
    mounted() {
      // this.listQuery = this.$route.query
      this.listQuery.serial = this.$route.query.serial
      this.listQuery.username = this.$route.query.username
      this.listQuery.password = ''
      this.listQuery.name = this.$route.query.name
      this.listQuery.personType = parseInt(this.$route.query.personType)
      this.listQuery.role = this.$route.query.role.split(';')
      this.listQuery.role = this.listQuery.role.map(Number)
      this.listQuery.permission = this.$route.query.permission.split(';')
      this.listQuery.permission = this.listQuery.permission.map(Number)
      this.listQuery.type = this.type.columns[this.listQuery.personType-1]
      this.listQuery.department = this.$route.query.department
      this.listQuery.position = this.$route.query.position
      this.listQuery.phone = this.$route.query.phone
      this.listQuery.email = this.$route.query.email
      this.listQuery.remark = this.$route.query.remark
      console.log(this.listQuery)
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$refs.update.submit()
      },
      submit() {
        Dialog.confirm({
          title: '确认更新用户？',
          message: '用户姓名：' + this.listQuery.name
        }).then(() => {
          this.loading = true
          const data = {
            id: this.listQuery.serial,
            username: this.listQuery.username,
            password: this.listQuery.password,
            name: this.listQuery.name,
            department: this.listQuery.department,
            position: this.listQuery.position,
            role: this.listQuery.role,
            permission: this.listQuery.permission,
            phone: this.listQuery.phone,
            email: this.listQuery.email,
            personType: this.listQuery.personType,
            remark: this.listQuery.remark
          }
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新用户', data.message)) {
              this.$router.push({ path:'/service/system/staff', query: {} })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '更新用户', '取消')
        })
      },
      validUserName(value) {
        return new Promise((resolve) => {
          const result = isUserName(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validPassword(value) {
        return new Promise((resolve) => {
          const result = isPassword(value, 6, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validName(value) {
        return new Promise((resolve) => {
          const result = isChinese(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validRole(value) {
        return new Promise((resolve) => {
          if ((value === '') || (value === null) || value === undefined || value.length === 0) {
            showPhoneAlarm(true, 'toast', null, 2000, null, '角色不能为空', null)
            resolve(false)
          } else {
            resolve(true)
          }
        })
      },
      validMobilePhone(value) {
        return new Promise((resolve) => {
          const result = isPhone(value)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validEmail(value) {
        return new Promise((resolve) => {
          const result = isEmail(value)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      handleGetDepartmentList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getDepartmentList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.department.columns = []
            for (let i=0; i<items.length; i++) {
              this.department.columns.push(items[i].name)
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleGetRoleList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getRoleList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.roleOptions = []
            for (let i=0; i<items.length; i++) {
              this.roleOptions.push({
                id: items[i].id,
                name: items[i].name
              })
            }
            this.role.list = items
            for(let i=0; i<items.length; i++) {
              this.role.columns.push(items[i].name)
            }
            this.handleChangeRole(this.listQuery.role)
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleChangeRole(value) {
        this.listQuery.role = value
        this.listQuery.permission = []
        if (value.length > 0) {
          for (let i=0; i<value.length; i++) {
            for (let j=0; j<this.role.list.length; j++) {
              if (value[i] === this.role.list[j].id) {
                for (let k=0; k<this.role.list[j].permissionList.length; k++) {
                  this.listQuery.permission.push(this.role.list[j].permissionList[k].id)
                }
              }
            }
          }
          this.listQuery.permission = this.listQuery.permission.filter(function(value, index, self) {
            return self.indexOf(value) === index
          })
        }
      },
      handlePersonTypeSelect(value) {
        this.listQuery.type = value
        this.listQuery.personType = this.type.columns.indexOf(value) + 1
        this.type.show = false
      },
      handleDepartmentSelect(value) {
        this.listQuery.department = value
        this.department.show = false
      }
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 5em;
  }
  ::v-deep .van-field__control:read-only {
    color: #999;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox__icon {
    font-size: 4.5vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
